import React, { useEffect, useRef } from "react";
import { notify } from "../../services/ui/notify";

const CronometroMonitor = ({
  isRunning,
  elapsedTime,
  startDate,
  mo,
  process,
  user,
  team,
  saveCallback,
}) => {
  const lastElapsedTimeRef = useRef(elapsedTime);
  const hasWarnedUser = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isRunning) {
        const currentElapsedTime = elapsedTime;

        if (
          currentElapsedTime === lastElapsedTimeRef.current &&
          lastElapsedTimeRef.current > 0
        ) {
          console.warn(
            "El cronómetro parece haberse detenido inesperadamente."
          );
          if (saveCallback) {
            saveCallback();
          }
        }
        lastElapsedTimeRef.current = currentElapsedTime;
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [isRunning, elapsedTime, saveCallback]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isRunning) {
        console.warn("Se detectó el cierre del navegador.");
        if (saveCallback) {
          saveCallback();
        }
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isRunning, saveCallback]);

  useEffect(() => {
    const handleOffline = () => {
      console.warn("Se perdió la conexión a internet.");
      if (saveCallback) {
        saveCallback();
      }

      if (!hasWarnedUser.current) {
        notify.warn(
          "Se perdió la conexión a internet. Los datos se han guardado temporalmente."
        );
        hasWarnedUser.current = true;
      }
    };

    const handleOnline = () => {
      console.info("Se ha restablecido la conexión a internet.");
      hasWarnedUser.current = false;
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [saveCallback]);

  useEffect(() => {
    const autosaveInterval = setInterval(() => {
      if (isRunning && saveCallback) {
        console.log("Auto-guardando estado del cronómetro...");
        saveCallback();
      }
    }, 10000);

    return () => clearInterval(autosaveInterval);
  }, [isRunning, saveCallback]);

  return null;
};

export default CronometroMonitor;
